import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      permissions: [],
      
      setSession: (token, user, permissions = []) => 
        set({ token, user, permissions }),
      
      logout: () => 
        set({ token: null, user: null, permissions: [] }),
      
      /**
       * Check if user has a specific permission
       * @param {string} code - Permission code (e.g., 'employees.read')
       * @returns {boolean}
       */
      hasPerm: (code) => {
        const { permissions } = get();
        return permissions.includes(code);
      },
      
      /**
       * Check if user has ALL of the specified permissions
       * @param {...string} codes - Permission codes
       * @returns {boolean}
       */
      hasAllPerms: (...codes) => {
        const { permissions } = get();
        return codes.every(code => permissions.includes(code));
      },
      
      /**
       * Check if user has ANY of the specified permissions
       * @param {...string} codes - Permission codes
       * @returns {boolean}
       */
      hasAnyPerm: (...codes) => {
        const { permissions } = get();
        return codes.some(code => permissions.includes(code));
      },
    }),
    { name: 'payroll-auth' },
  ),
);
